export default function EmailDomainWarning() {
  return (
    <div className="
      p-2 mt-2 rounded-md 
      bg-red-500/20 border border-red-400/40 
      text-red-300 text-xs
    ">
      Personal email domains (gmail, yahoo, etc.) are not allowed.
      Please use your company email address.
    </div>
  );
}
